import Promise from "bluebird";
import JsZip from "jszip";
import FileSaver from "file-saver";

const download = (url) => {
  return fetch(url).then((resp) => resp.blob());
};

const downloadByGroup = (urls, files_per_group = 5) => {
  return Promise.map(
    urls,
    async (url) => {
      return await download(url);
    },
    { concurrency: files_per_group }
  );
};

const exportZip = (blobs) => {
  const zip = JsZip();
  blobs.forEach((blob, i) => {
    zip.file(`image-${i}.png`, blob);
  });
  zip.generateAsync({ type: "blob" }).then((zipFile) => {
    const currentDate = new Date().getTime();
    const fileName = `images-${currentDate}.zip`;
    return FileSaver.saveAs(zipFile, fileName);
  });
};

export const downloadAndZip = (urls) => {
  return downloadByGroup(urls, urls.length).then(exportZip);
};

export function savePdfFromBase64(base64String, fileName) {
  const linkSource = `${base64String}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}